<!--
程序名：文书设计主页面
功能：对文书进行设计
-->
<template>
    <div>
        <el-dialog
            title="设计文书"
            :visible.sync="visibleSync"
            :width="width"
            custom-class="designDialog"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            :before-close="designClose"
            v-if="visibleSync"
        >
            <div :style="getstyle()">
                <el-row>
                    <el-col :span="6">
                        <!--操作栏-->
                        <div class="opera">
                            <el-tooltip class="item" effect="dark" content="创建文书" placement="bottom">
                                <el-button icon="el-icon-plus" type="text" class="rightButton" @click="addWjButtonClick" :disabled="this.wjList.length > 0"></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="编辑文书" placement="bottom">
                                <el-button icon="el-icon-edit" type="text" class="rightButton" @click="editWj" :disabled="nowSelect.id == 0 || nowSelect.id == null || ReadOnly == true"></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="保存" placement="bottom">
                                <el-button icon="el-icon-video-play" type="text" class="rightButton" @click="pushWj" :disabled="ReadOnly == true"></el-button>
                            </el-tooltip>
                            <!-- <el-tooltip class="item" effect="dark" content="预览文书" placement="bottom">
            <el-button icon="el-icon-view" type="text" class="rightButton" @click="previewWj" :disabled="nowSelect.id==0||nowSelect.id==null"></el-button>
          </el-tooltip> -->
                            <!-- <el-tooltip class="item" effect="dark" content="删除文书" placement="bottom">
                                <el-button
                                    icon="el-icon-delete"
                                    type="text"
                                    class="rightButton"
                                    @click="deleteWj"
                                    :disabled="nowSelect.id == 0 || nowSelect.id == null || ReadOnly == true"
                                ></el-button>
                            </el-tooltip> -->
                        </div>

                        <!--左侧导航栏-->
                        <el-menu :default-active="defaultActive.toString()" v-loading="loading" class="menu">
                            <!--文书列表-->
                            <div style="width: 100%; text-align: center; font-size: 15px; line-height: 20px; margin-top: 20px; color: #303133" v-if="nowSelect.id == 0 || nowSelect.id == null">
                                点击上方&nbsp;+&nbsp;创建移动端文书模板
                            </div>
                            <el-menu-item v-for="(item, index) in wjList" :index="(index + 1).toString()" :key="item.id">
                                <i class="el-icon-tickets" style="margin-right: 0px"></i>
                                <span slot="title" style="display: inline-block">
                                    {{ item.paper_name }}
                                </span>
                            </el-menu-item>
                        </el-menu>
                    </el-col>

                    <el-col :span="18">
                        <!--标签页-->
                        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="文书设计" name="wjsj">
                                <!--内容区域-->
                                <div class="content">
                                    <div v-show="nowSelect.id == 0 || nowSelect.id == null">请先选择文书</div>
                                    <design ref="design" v-show="nowSelect.id != 0 && nowSelect.id != null" @designData="questionData" :ReadOnly="ReadOnly"></design>
                                </div>
                            </el-tab-pane>
                            <!-- 暂时不要 -->
                            <!-- <el-tab-pane label="患者信息设置" name="patientInfo">
                                <div class="content" ref="pdf">
                                    <div v-show="nowSelect.id == 0 || nowSelect.id == null">请先选择文书</div>
                                    <div style="width: 1020px" v-if="nowSelect.id != 0 && nowSelect.id != null">
                                        <div style="float: left" v-if="ReadOnly == false">
                                            <div class="configcolumn" style="text-align: left"><el-row class="ellipsis">字段选择</el-row></div>
                                            <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: `${this.screenHeight2 - 290}px`, width: `200px` }">
                                                <div class="config-column config-column_drop">
                                                    <item-input type="checkboxgroup" :options="columnList" v-model="user_config_columns"></item-input>
                                                </div>
                                            </el-scrollbar>
                                        </div>
                                        <div style="float: left; width: 300px; height: 300px">
                                            <div class="configcolumn" style="text-align: left"><el-row class="ellipsis">小程序患者信息设置</el-row></div>
                                            <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: `${this.screenHeight2 - 290}px`, width: `300px` }">
                                                <div
                                                    class="padding5 padding-none-v align-left el-col el-col-24"
                                                    style="width: 300px; background-color: #33aba0; color: white; padding: 5px; border-radius: 10px; margin-top: 20px"
                                                >
                                                    <el-row class="ellipsis">
                                                        <el-col :span="24" class="align-center"> 患者信息 </el-col>
                                                    </el-row>
                                                    <div class="align-left" v-for="item in userListColumn" :key="item.key">{{ item.label }}</div>
                                                </div>
                                            </el-scrollbar>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane> -->
                        </el-tabs>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>

        <!--添加文书弹窗-->
        <el-dialog title="添加移动端文书" :visible.sync="dialogShow" width="30%" :close-on-click-modal="false">
            <el-form ref="form" :model="willAddWj" label-position="left" label-width="70px">
                <el-form-item label="文书标题" required>
                    <el-input v-model="willAddWj.paper_name" placeholder="请输入文书标题"></el-input>
                </el-form-item>
                <el-form-item label="使用角色" required>
                    <!-- <el-input v-model="willAddWj.desc" type="textarea" placeholder="请输入文书描述" rows="5"></el-input> -->
                    <el-select v-model="willAddWj.enum_worker_role" placeholder="请选择" style="width: 100%">
                        <el-option v-for="item in [{value: 0,label: `通用`,jianpin: `TY`,code: ``}].concat(this.sys_enums.Enum_WorkerRole)" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="DocId" required>
                    <el-input v-model="willAddWj.doc_id" placeholder="请输入文书系统对应的文书编号"></el-input>
                </el-form-item>
            </el-form>
            <div style="width: 100%; text-align: right; margin-bottom: 20px">
                <!-- <el-button style="margin-left: 10px;" @click="openTemp">从模板库创建</el-button> -->
                <el-button style="margin-left: 10px" @click="dialogShow = false">取消</el-button>
                <el-button type="primary" style="margin-left: 10px" @click="addSync">同步</el-button>
            </div>
        </el-dialog>

        <!--模板库弹窗-->
        <el-dialog title="模板库" :visible.sync="tempDialog" :close-on-click-modal="false">
            <el-input placeholder="请输入关键词搜索" prefix-icon="el-icon-search" v-model="tempSearchText"></el-input>
            <el-table :data="tempData" style="width: 100%" v-loading="tempLoading" element-loading-text="加载中...">
                <el-table-column prop="tempname" label="模板名" width="250"></el-table-column>
                <el-table-column prop="username" label="创建者"></el-table-column>
                <el-table-column label="预览">
                    <el-link slot-scope="scope" type="primary" @click="lookTempWj(scope.row)">预览</el-link>
                </el-table-column>
                <el-table-column label="操作">
                    <el-link slot-scope="scope" type="primary" @click="useTemp(scope.row)">使用此模板</el-link>
                </el-table-column>
            </el-table>
            <el-pagination layout="prev, pager, next" :total="tempDataCount" @current-change="changeTempPage" :page-sizel="5"></el-pagination>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Design from './Design.vue'
import Sortable from 'sortablejs'
import draggable from 'vuedraggable'
// import DataShow from './DataShow.vue'
import ElButton from "../../node_modules/element-ui/packages/button/src/button"
export default{
    name: `document-edit`,
    inject: [`reload`],
    components: {
        ElButton,
        Design,
        draggable
        // QRCode,
    },
    props: {
        dialogVisible: { type: Boolean, default: false },
        ReadOnly: { type: Boolean, default: false },
        width: {
            type: String,
            default: `60%`
        }
    },
    data() {
        return {
            user_config_columns: [],
            configColumns: [],
            questionPaper: {},
            currentId: 0, // 自增id，用于缓存当前每次新增的id
            defaultActive: 1, // 当前激活菜单
            activeName: `wjsj`, // 标签页当前选择项
            wjList: [], // 文书列表
            loading: false, // 是否显示加载中
            dialogShow: false, // 添加文书弹窗是否显示
            tempDialog: false, // 模板库弹窗是否显示
            //        nowTempData:[],//当前模板库页码
            tempData: [],
            tempDataCount: 0,
            tempLoading: false,
            tempSearchText: ``,
            willAddWj: {
                id: 0,
                paper_name: ``,
                enum_worker_role: 1,
                doc_id: ``
            },
            shareInfo: {
                url: ``
            }

        }
    },
    created() {
    },
    mounted() {

    },
    computed: {
        ...mapGetters([`screenHeight`, `sys_enums`]),
        screenHeight2() {
            return this.screenHeight
        },
        userListColumn() {
            let that = this
            if (this.user_config_columns.length == 0) {
                return []
            }
            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.value) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            return r
        },
        columnList() {
            let list = [
                {
                    type: `string`,
                    value: `Surgery`,
                    label: `手术名称`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `PlanTime`,
                    label: `手术时间`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `PatientName`,
                    label: `患者名称`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `VisitNo`,
                    label: `住院号`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `Age`,
                    label: `年龄`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `Sex`,
                    label: `性别`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `Anesthesiologist`,
                    label: `麻醉医生`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `SectionName`,
                    label: `科室`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `InpatientSectionName`,
                    label: `病区`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `OperatingRoomName`,
                    label: `手术间`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `AnaesthesiaMethod`,
                    label: `麻醉方式`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `Surgeon`,
                    label: `手术医生`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `Remark`,
                    label: `备注`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `Sequence`,
                    label: `台次`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `IsFasting`,
                    label: `术前禁食`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `Infectious`,
                    label: `传染病`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `Disease`,
                    label: `诊断`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `VisitTime`,
                    label: `入院时间`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `CostTime`,
                    label: `预计时长`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `SurgeryType`,
                    label: `手术类型`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `SurgeryScale`,
                    label: `手术分级`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `OperatingWardName`,
                    label: `手术区`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `BloodType`,
                    label: `血型`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `Height`,
                    label: `身高`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `RhBloodType`,
                    label: `RH`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `Weight`,
                    label: `体重`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `ASA`,
                    label: `ASA`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `string`,
                    value: `His_Remark`,
                    label: `申请备注`,
                    width: `80`,
                    isListable: true
                }
            ]
            return list
        },
        visibleSync: {
            get: function() {
                return this.dialogVisible
            },
            set: function(newval) {
                this.$emit(`update:dialogVisible`, newval)
                this.$emit(`closeDesign`, newval)
            }
        },
        // 现在选中的文书信息
        nowSelect() {
            console.log(`nowSelect update`)
            let now = this.wjList[this.defaultActive - 1]
            if (this.wjList.length == 0) {
                return {
                    id: 0,
                    paper_name: ``,
                    enum_worker_role: 1,
                    doc_id: ``
                }
            }
            var currnetSelect = {
                id: now.id,
                paper_name: now.paper_name,
                enum_worker_role: now.enum_worker_role,
                doc_id: now.doc_id
            }
            return currnetSelect
        }
    },
    methods: {
        initData(readOnly) {
            var that = this
            that.wjList = []
            that.user_config_columns = []
            that.ReadOnly = readOnly
            that.questionPaper = {}
        },
        loadData(documentid, readOnly) {
            var that = this
            that.initData(readOnly)
            if (documentid > 0) {
                let req = this.myaxios.get(`/api/MobilePaper/MobilePaper/Get?id=` + documentid)
                req.then(data => {
                    if (data) {
                        that.wjList.push(data)
                        that.questionPaper = data
                        that.getWjList()
                    }
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        handleClick(e) {
            if (e.name == `patientInfo`) {
                this.configColumnDrop()
            }
        },
        configColumnDrop() {
            const tbody = document.querySelector(`.config-column_drop .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        },
        questionData(documentData) {
            this.questionPaper = this.nowSelect
            this.questionPaper.questionModels = documentData
        },
        designClose() {
            this.visibleSync = false
        },
        getstyle() {
            if (this.overflow) {
                return { 'max-height': `${this.screenHeight - 200}px`, overflow: `auto` }
            } else {
                return { 'max-height': `${this.screenHeight - 200}px` }
            }
        },
        addTemp() {

        },
        // 使用文书
        useTemp(item) {
            this.tempLoading = true
        },
        // 打开文书库
        openTemp() {
            this.tempDialog = true
            this.changeTempPage(1)
        },
        // 改变模板库页码
        changeTempPage(page) {
            this.tempLoading = true
        },
        // 预览模板文书
        lookTempWj(item) {
            let url = window.location.origin + `/tempdisplay/` + item.tempid// 文书链接
            console.log(url)
            window.open(url)
        },
        // 发布文书
        pushWj() {
            var questionPaper = this.questionPaper
            if (!questionPaper.questionModels) {
                this.$message({
                    type: `error`,
                    message: `请配文书题目`
                })
                return
            }
            let req = this.myaxios.post(`/api/MobilePaper/MobilePaper/Post`, this.questionPaper)
            req.then(data => {
                if (data) {
                    this.$message({
                        type: `success`,
                        message: `保存成功`
                    })
                    this.designClose()
                }
            }).catch(e => {
                console.log(e)
            })
        },
        // 预览文书
        previewWj() {
            let url = window.location.origin + `/display/` + this.nowSelect.id// 文书链接
            console.log(url)
            window.open(url)
        },
        // 编辑文书
        editWj() {
            this.willAddWj = this.nowSelect
            this.dialogShow = true
        },
        // 添加文书按钮点击
        addWjButtonClick() {
            if (this.wjList.length > 0) {
                this.$message({
                    type: `error`,
                    message: `无法创建多个文书`
                })
            } else {
                this.dialogShow = true
                // this.currentId += 1
                this.willAddWj = {
                    id: this.currentId,
                    paper_name: ``,
                    enum_worker_role: 1,
                    doc_id: ``
                }
            }
        },
        // 添加文书
        addSync() {
            if (this.willAddWj.paper_name == ``) {
                this.$message({
                    type: `error`,
                    message: `文书名称不能为空`
                })
                return
            }
            if (this.willAddWj.doc_id == ``) {
                this.$message({
                    type: `error`,
                    message: `映射文书不能为空`
                })
                return
            }
            let req = this.myaxios.post(`/api/MobilePaper/MobilePaper/Sync`, this.willAddWj)
            req.then(data => {
                if (data) {
                    this.$message({
                        type: `success`,
                        message: `同步成功`
                    })
                    this.loadData(data.id, this.ReadOnly)
                }
            }).catch(e => {
                console.log(e)
            })
            this.getWjList()
            this.dialogShow = false
        },
        // 获取文书列表
        getWjList() {
            this.lookDetail()
        },
        // 删除文书
        deleteWj() {
            this.$confirm(`确定删除` + this.nowSelect.paper_name + `? 删除后不可恢复！`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            }).then(() => {
                this.wjList.splice(this.defaultActive - 1, 1)
            })
        },
        // 文书点击
        wjClick(id, index) {
            this.defaultActive = (index + 1).toString()
            this.lookDetail()
        },
        // 查看文书详情
        lookDetail() {
            var detail = this.questionPaper.questionModels == null ? [] : this.questionPaper.questionModels
            this.$refs.design.init(this.nowSelect.id, this.nowSelect.paper_name, this.nowSelect.paper_name, detail)
            console.log(`id=`)
            console.log(this.nowSelect.id)
            // this.$refs.dataShow.dataAnalysis(this.nowSelect.id)
        }
    }
}
</script>
<style scoped>
.designDialog {
    margin-top: 15vh !important;
}
.home {
    position: absolute;
    width: 100%;
    height: calc(100vh - 100px);
    text-align: left;
}
.home .badgeItem {
    margin-top: 40px;
}
.content {
    padding: 20px;
    padding-right: 50px;
    height: calc(100vh - 175px);
    text-align: center;
    overflow-y: scroll;
    overflow-x: hidden;
}
.menu {
    background-color: white;
    height: calc(100vh - 100px);
    overflow-x: scroll;
    overflow-y: scroll;
    left: 0;
}
.home .opera {
    position: relative;
    background-color: #fafafa;
    text-align: center;
    height: 40px;
}
.home .rightButton {
    font-size: 16px;
}
.home .addWjDiv {
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-bottom: 1px solid #eee;
}

.config-column {
    width: 200px;
    overflow: hidden;
    margin: 20px 0;
}
.config-column .el-checkbox-group .el-checkbox {
    display: table-row;
}
</style>



// WEBPACK FOOTER //
// src/common/DocumentEdit.vue